export enum Channel {
  toGo = 1,
  tvm = 2,
  vix = 3,
  hectronic = 4,
  foretagsportalen = 5,
  skolkortswebb = 6,
  ombud = 7,
  ombord = 8,
  chalmersbutiker = 9,
  techpay = 10,
  tapAndGo = 14,
}
